<template>
  <bb-modal
    :visible="!!visible"
    flavor="card"
    public-size="m"
    class="align-center"
    full-mobile
    static-overlay
    @close="$emit('close')"
  >
    <bb-icon :name="iconName" size="64" fill="original" />
    <p class="m-t-20">
      {{ challengeId }}
    </p>
    <p class="f-color-gray-70 m-t-20 m-b-20">
      {{ $t('digitalAuthenticationMethods.pinText') }}
    </p>
    <bb-link
      id="closeModalLink"
      @click="$emit('close')"
    >
      {{ $t('digitalAuthenticationMethods.cancel') }}
    </bb-link>
  </bb-modal>
</template>

<script>
  import { BbModal, BbIcon, BbLink } from '@bigbank/interface-components';
  import { VerificationMethods } from '@/types/common/enums';

  export default {
    name: 'smart-id-challenge-id-modal',
    components: {
      BbModal,
      BbIcon,
      BbLink,
    },
    props: {
      visible: Boolean,
      challengeId: String,
      activeVerificationMethod: String,
    },
    computed: {
      iconName () {
        return this.activeVerificationMethod === VerificationMethods.MOBILE_ID
          ? 'client-mobile-id'
          : 'client-smart-id';
      },
    },
  };
</script>
